<template>
    <div class="col-12 mt-5">
        <h3 class="h5 mb-3">{{ $t("warehouses.stockChanges") }}</h3>
    </div>
    <div class="col-12">
        <Table :endpoint="'/product_stock_changes/' + warehouseId" :filters="filters" ref="table">
            <template v-slot:filters>
                <div class="col-12 col-md-4 mb-2">
                    <select v-model="filters.product" class="form-select">
                        <option :value="null">{{ $t("warehouses.allProducts") }}</option>
                        <option v-for="item in products" :key="item.id" :value="item.id">
                            {{ item.shorten_name }} – {{ item.name }}
                        </option>
                    </select>
                </div>
                <div class="col-12 col-md-3 mb-2">
                    <select v-model="filters.change_type" class="form-select">
                        <option :value="null">{{ $t("warehouses.allTypes") }}</option>
                        <option v-for="type in changeTypes" :key="type" :value="type">
                            {{ $t("warehouses.changeType." + type) }}
                        </option>
                    </select>
                </div>
            </template>
            <template v-slot:header>
                <div class="col-lg-2 d-none d-lg-block">{{ $t("products.timeDateChange") }}</div>
                <div class="col-lg-1 d-none d-lg-block">{{ $t("warehouses.changeTypeLabel") }}</div>
                <div class="col-lg-2 d-none d-lg-block">{{ $t("warehouses.product") }}</div>
                <div class="col-lg-2 d-none d-lg-block">{{ $t("warehouses.piecesChange") }}</div>
                <div class="col-lg-3 d-none d-lg-block">{{ $t("warehouses.note") }}</div>
                <div class="col-lg-2 d-none d-lg-block">{{ $t("products.changedBy") }}</div>
            </template>
            <template #row="line">
                <div class="col-6 col-lg-2 small">{{ line.item.created }}</div>
                <div class="col-6 col-lg-1 text-end text-lg-start">
                    <span class="badge" :class="typeClass(line.item.change_type)">
                        {{ $t("warehouses.changeType." + (line.item.change_type || "other")) }}
                    </span>
                </div>
                <div class="col-6 col-lg-2 fw-bold">{{ line.item.product_stock.product.shorten_name }}</div>
                <div class="col-6 col-lg-2 text-end text-lg-start fw-bold"
                    :class="line.item.amount < 0 ? 'text-danger' : 'text-primary'">
                    <span :class="{ 'text-decoration-line-through opacity-50': line.item.cancelled }">
                        {{ line.item.amount > 0 ? "+" : "" }}{{ formatAmount(line.item.amount) }}
                        {{ line.item.product_stock.product.measurement_unit }}
                    </span>
                    <span v-if="line.item.cancelled" class="badge bg-light text-dark ms-1">
                        {{ $t("warehouses.cancelled") }}
                    </span>
                </div>
                <div class="col-12 col-lg-3 small">
                    <router-link v-if="line.item.order" :to="{ name: 'OrderDetail', params: { id: line.item.order } }">
                        {{ $t("warehouses.order") }} {{ line.item.order_intern_id }}
                    </router-link>
                    <span v-if="line.item.order && line.item.note"> – </span>
                    <span>{{ line.item.note }}</span>
                </div>
                <div class="col-12 col-lg-2 small text-muted d-flex justify-content-between align-items-center gap-2">
                    <span>{{ personName(line.item.created_by) }}</span>
                    <button v-if="line.item.can_cancel" type="button" class="btn btn-sm btn-outline-danger"
                        @click="cancelChange(line.item)">
                        {{ $t("warehouses.cancel") }}
                    </button>
                </div>
            </template>
        </Table>
    </div>
</template>
<script>
import Table from "@/components/Table.vue";

export default {
    components: {
        Table,
    },
    props: {
        warehouseId: {
            type: [String, Number],
            required: true,
        },
        products: {
            type: Array,
            default: () => [],
        },
    },
    emits: ["changed"],
    data() {
        return {
            filters: { product: null, change_type: null },
            changeTypes: ["receipt", "issue", "conversion", "inventory", "order", "storno"],
        };
    },
    methods: {
        reload() {
            this.$refs.table.loadData();
        },
        cancelChange(item) {
            const product = item.product_stock.product;
            const text = this.$t("warehouses.confirmCancel", {
                type: this.$t("warehouses.changeType." + item.change_type),
                amount: this.formatAmount(item.amount),
                unit: product.measurement_unit,
                product: product.shorten_name
            });
            if (!confirm(text)) {
                return;
            }
            this.$store.getters.api.put("/product_stock_change/" + item.id + "/cancel").then(() => {
                this.$emit("changed");
            }).catch(() => {
                alert(this.$t("warehouses.entryError"));
            });
        },
        typeClass(type) {
            const classes = {
                receipt: "bg-success",
                issue: "bg-danger",
                conversion: "bg-primary",
                inventory: "bg-dark",
                order: "bg-secondary text-dark",
                storno: "bg-warning text-dark",
            };
            return classes[type] || "bg-light text-dark";
        },
        personName(user) {
            if (!user) return "—";
            const full = [user.first_name, user.last_name].filter(Boolean).join(" ");
            return full || user.username;
        },
    },
};
</script>
